import React, {useState} from "react";
import PropTypes from "prop-types";
import { Grid, Button, Modal } from "@mui/material";
import Card from "../../../components/Cards/Card";
import NativeObject from "../../../components/NativeObject/NativeObject";
import { ReactComponent as IconExpadion } from "../../../assets/icons/iconExpadion.svg";

const OBJECT_IDS = {
  COBERTURA_BASE_TABLE: "jmqMqxm",
};

const ResultadosCard = ({ app, onDetailClick, isLoading, segment }) => {

  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const TABLE_ID =
    segment === "farma"
      ? "832eb60b-b781-4138-841c-aa526c3684d8"
      : OBJECT_IDS.COBERTURA_BASE_TABLE;

  return (
    <>
      <Grid container className="container-cards-kpi">
        <Card
          app={app}
          className={"card-kpi-item"}
          header={{
            hardTitle: "Resultados",
          }}
          expandable
          exportContainer
          exportTable
          exportTableId={TABLE_ID}
        >
          <Button
            className="detail-button"
            variant="outlined"
            onClick={handleOpenModal}
            endIcon={<IconExpadion />}
            disabled={isLoading}
          />
          <NativeObject
            app={app}
            key={TABLE_ID}
            style={{ width: "100%", height: "300px" }}
            reference={{ id: TABLE_ID }}
            className={"table-item-ranking"}
          />
        </Card>
      </Grid>

      <Modal open={openModal} onClose={handleCloseModal}>
        <Grid
          className="card"
          flexDirection="column"
          justifyContent="center"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "70%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
          }}
        >
          <NativeObject
            app={app}
            key={TABLE_ID}
            reference={{ id: TABLE_ID }}
            style={{ width: "100%", height: "400px" }}
          />
        </Grid>
      </Modal>
    </>
  );
};

ResultadosCard.propTypes = {
  app: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  segment: PropTypes.string,
};

export default ResultadosCard;
